// =============================================================================
// reducers/kpiRuleReducer.js
// =============================================================================
import {
	RULES_FETCH_REQUEST, RULES_FETCH_SUCCESS, RULES_FETCH_FAILURE,
	RULE_SAVE_REQUEST,   RULE_SAVE_SUCCESS,   RULE_SAVE_FAILURE,
	RULE_DELETE_REQUEST, RULE_DELETE_SUCCESS, RULE_DELETE_FAILURE,
	RULE_SELECT,
	RULE_FORM_RESET,
	FORMULA_VALIDATE_REQUEST, FORMULA_VALIDATE_SUCCESS, FORMULA_VALIDATE_FAILURE, FORMULA_VALIDATE_RESET,
	ENGINE_LOGS_FETCH_REQUEST, ENGINE_LOGS_FETCH_SUCCESS, ENGINE_LOGS_FETCH_FAILURE,
	EMPTY_RULE,
} from '../constants/kpiConstants';

const initialState = {
	// Rule list
	items:        [],
	loading:      false,
	error:        null,

	// Rule being edited
	selectedRule: null,

	// Save state
	saving:       false,
	saveError:    null,
	saveSuccess:  false,

	// Delete state
	deleting:     false,

	// Formula validation
	validation: {
		loading: false,
		result:  null,   // { isValid, errorMessage, sampleKpi, sampleVolume }
		error:   null,
	},

	// Engine logs
	engineLogs:        [],
	engineLogsLoading: false,
	engineLogsError:   null,
};

export default function kpiRuleReducer(state = initialState, action) {
	switch (action.type) {
		case RULES_FETCH_REQUEST:
			return { ...state, loading: true, error: null };
		case RULES_FETCH_SUCCESS:
			return { ...state, loading: false, items: action.payload };
		case RULES_FETCH_FAILURE:
			return { ...state, loading: false, error: action.payload };

		case RULE_SELECT:
			return { ...state, selectedRule: action.payload, saveSuccess: false, saveError: null,
				validation: { loading: false, result: null, error: null } };

		case RULE_FORM_RESET:
			return { ...state, selectedRule: { ...EMPTY_RULE }, saveSuccess: false, saveError: null,
				validation: { loading: false, result: null, error: null } };

		case RULE_SAVE_REQUEST:
			return { ...state, saving: true, saveError: null, saveSuccess: false };
		case RULE_SAVE_SUCCESS:
			return { ...state, saving: false, saveSuccess: true, selectedRule: null };
		case RULE_SAVE_FAILURE:
			return { ...state, saving: false, saveError: action.payload };

		case RULE_DELETE_REQUEST:
			return { ...state, deleting: true };
		case RULE_DELETE_SUCCESS:
			return { ...state, deleting: false, selectedRule: null };
		case RULE_DELETE_FAILURE:
			return { ...state, deleting: false, saveError: action.payload };

		case FORMULA_VALIDATE_REQUEST:
			return { ...state, validation: { loading: true, result: null, error: null } };
		case FORMULA_VALIDATE_SUCCESS:
			return { ...state, validation: { loading: false, result: action.payload, error: null } };
		case FORMULA_VALIDATE_FAILURE:
			return { ...state, validation: { loading: false, result: null, error: action.payload } };
		case FORMULA_VALIDATE_RESET:
			return { ...state, validation: { loading: false, result: null, error: null } };

		case ENGINE_LOGS_FETCH_REQUEST:
			return { ...state, engineLogsLoading: true, engineLogsError: null };
		case ENGINE_LOGS_FETCH_SUCCESS:
			return { ...state, engineLogsLoading: false, engineLogs: action.payload };
		case ENGINE_LOGS_FETCH_FAILURE:
			return { ...state, engineLogsLoading: false, engineLogsError: action.payload };

		default:
			return state;
	}
}
